import { Vector3, Quaternion } from './three'

export const PLAYER_STEP_HEIGHT = 0.35
export const PLAYER_MAX_SLOPE = 50
const UP = new Vector3(0, 1, 0)
const DOWN = new Vector3(0, -1, 0)
const ROTATION = new Quaternion().setFromAxisAngle(new Vector3(0, 0, 1), Math.PI / 2)
const SKIN = 0.02

// Queries only. The caller applies the result through the existing dynamic body.
export function findPlayerStep({
  physics,
  geometry,
  position,
  direction,
  radius,
  height,
  distance,
  mask,
  stepHeight = PLAYER_STEP_HEIGHT,
  maxSlope = PLAYER_MAX_SLOPE,
}) {
  if (!(distance > 0 && stepHeight > 0) || direction.lengthSq() < 0.0001) return null
  const forward = new Vector3(direction.x, 0, direction.z).normalize()
  const centre = position.clone().addScaledVector(UP, height / 2 + SKIN)
  const minNormalY = Math.cos((maxSlope * Math.PI) / 180)
  const obstacle = physics.sweep(geometry, centre, forward, distance, mask, ROTATION)
  // Flat ground and walkable ramps use normal locomotion; step only at a riser.
  if (!obstacle || obstacle.normal.y >= minNormalY) return null

  const lift = stepHeight + 0.08 + SKIN
  if (physics.sweep(geometry, centre, UP, lift, mask, ROTATION)) return null
  const raised = centre.clone().addScaledVector(UP, lift)
  if (physics.sweep(geometry, raised, forward, distance, mask, ROTATION)) return null
  const destination = raised.clone().addScaledVector(forward, distance)
  const landing = physics.sweep(geometry, destination, DOWN, lift, mask, ROTATION)
  if (!landing || landing.normal.y < minNormalY || !Number.isFinite(landing.distance)) return null
  // Copy values before the next query: Physics reuses its hit objects.
  const rise = lift - landing.distance
  if (rise <= SKIN || rise > stepHeight) return null
  // Require an actual tread ahead, excluding rounded capsule contact on walls.
  const treadOrigin = position
    .clone()
    .addScaledVector(forward, distance + radius)
    .addScaledVector(UP, lift)
  const tread = physics.raycast(treadOrigin, DOWN, lift + SKIN, mask)
  if (!tread || tread.normal.y < minNormalY) return null
  const treadRise = tread.point.y - position.y
  if (treadRise <= SKIN || treadRise > stepHeight) return null
  return position
    .clone()
    .addScaledVector(forward, distance)
    .addScaledVector(UP, rise + SKIN)
}
